import { keyframes } from '@mui/system';
import { Box } from '@mui/material';
import type { FC } from 'react';

// Define the pulsing animation
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
`;

const SlashScreen: FC<React.PropsWithChildren<unknown>> = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
    }}
  >
    <Box
      sx={{
        backgroundColor: '#CCC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '220px',
        height: '180px',
        padding: '20px',
        borderRadius: '10px',
        animation: `${pulse} 1s infinite`, // Apply the pulsing animation
      }}
    >
      <img
        alt="Logo"
        src="/static/sfa_logo_white.svg"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </Box>
  </Box>
);

export default SlashScreen;
